import { render, staticRenderFns } from "./RegistrationGuideModal.vue?vue&type=template&id=258ea9e2&scoped=true&"
import script from "./RegistrationGuideModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationGuideModal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationGuideModal.vue?vue&type=style&index=0&id=258ea9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ea9e2",
  null
  
)

export default component.exports